import { useEffect, useState } from 'react';

const useDebounce = <T>(value: T, timeout = 500) => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timeoutRef = setTimeout(() => {
      setDebouncedValue(value);
    }, timeout);

    return () => {
      clearTimeout(timeoutRef);
    };
  }, [value, timeout]);

  return debouncedValue;
};

export default useDebounce;
